<template>
  <div ref="listWrap">
    <wrapper-list
      @add="paasAddPage"
      @edit="paasEidtPage"
      @delete="paasDeleteTableData"
      @detail="paasDetailPage"
      @calculate="paasCalculate"
      ref="listWrap">
      <Form class="list-query-wrap" slot="query" :model="queryParam" :label-width="defaultLabelWidth" ref="queryForm">
        <Row>
          <FormItem label="角色名称:" class="ivu-col-span-24">
            <Input  v-model="queryParam.query_LIKE_name"  @on-change="queryTableDatas" clearable style="width: auto" />
          </FormItem>
        </Row>
      </Form>
      <Table slot="table" stripe border :height="tableHeight"
             :data="tableData"
             :columns="tableColumns"
             @on-selection-change="selectTableDataChange"
             @on-sort-change="sortTableData"
             :no-data-text="noDataText">
      </Table>
      <Page slot="page"  :total="totalRecords"
            show-total show-sizer
            @on-change="changePage"
            @on-page-size-change="changePageSize">
      </Page>
    </wrapper-list>
    <Modal v-model="funcSelectModal" class="paas-select-page select-page"
           :styles="{top: '20px'}" width="60" title="功能选择">
      <FuncSelect ref="selectFunc" :funcData="roleFuncIds" @save="saveRoleFunc" style="height: calc(100vh - 140px)"/>
      <div slot="footer">
      </div>
    </Modal>
  </div>
</template>

<script>
  import wrapperList from "@components/paas/wrapper-list";
  import metaList from "@assets/js/list/meta-list.js";
  import Enum from '@components/paas/query-enum' //枚举查询
  import EnumShow from "@components/paas/enum-show";  //如果有枚举，需要引入
  import CellBar from '@components/paas/cell-bar' //列表内操作
  import FuncSelect from '@views/sys/func/select';
  import { getRoleFunc , saveRoleFunc} from "@api/admin.js";
  export default {
    name: "list",
    components:{wrapperList,Enum,EnumShow,CellBar,FuncSelect},
    mixins: [ metaList],
    data(){
      return{
        serviceUrl:"/sys/role",  //每个页面访问后台服务器的路径
        currentIdFiledName: 'id',
        queryParam:{
          query_LIKE_name:'',
        },
        //keepAliveName:"sysBugEdit",  //从这些路由到当前list路由需要缓存list的配置
        defaultLabelWidth:120,
        tableHeight:0,
        tableData:[],  //表单数据
        tableColumns:[
          /*{
            type:'selection',
            key:'id',
            width:36,
            align:'center'
          },*/
          {
            title: '角色名称',
            key: 'name',
            align:'center'
          },
          {
            title: '角色描述',
            key: 'sysRoleDesc',
            align:'center',
          },
          {
            title:'操作',
            align:'center',
            width:200,
            render:(h,params)=>{
              return h(CellBar,{
                props:{
                  show:"icon",
                },
                on: {
                  'edit': ()=> {
                    this.$nextTick(()=>{
                      this.paasEditOper(params.row[this.currentIdFiledName]);
                    })
                  },
                  'delete':()=>{
                    this.$nextTick(()=>{
                      this.paasDeleteOper(params.row[this.currentIdFiledName]);
                    })
                  },
                  'detail':()=>{
                    this.$nextTick(()=>{
                      this.paasDetailOper(params.row[this.currentIdFiledName]);
                    })
                  },
                  'assignFunc':()=>{
                    this.$nextTick(()=>{
                      this.tableSelectedDatas = [params.row];
                      this.roleFuncSelect();
                    })
                  }
                }
              })
            }
          },
        ],
        funcSelectModal: false,
        roleFuncIds: []
      }
    },
    methods:{
      roleFuncSelect() {
        ;
        if(this.tableSelectedDatas.length !== 1) {
          this.$Modal.warning({
            title: "系统提示",
            content: "请选择一个角色数据!"
          });
          return ;
        }
        let id = this.tableSelectedDatas[0].id;
        getRoleFunc(id).then(res=>{
          if(res.code === 200) {
            this.funcSelectModal = true;
            this.roleFuncIds = res.data;
          }
        }).catch(res=> {
          this.$Message.error("操作失败，请重试！");
        });
      },
      saveRoleFunc(nodes) {
        let sysFuncIds = "";
        for(let i = 0; i < nodes.length; i++) {
          if(sysFuncIds) {
            sysFuncIds += ",";
          }
          sysFuncIds += nodes[i].id;
        }
        let param = {};
        param.sysRoleId = this.tableSelectedDatas[0].id;
        param.sysFuncIds = sysFuncIds;
        saveRoleFunc(param).then(res=> {
          ;
          if(res.code === 200) {
            this.funcSelectModal = false;
            this.$Message.info("保存成功！");
          }
        }).catch(error=>{
          this.$Message.error("操作失败，请重试！");
        });
      }
    }
  }
</script>

<style scoped>

</style>
